import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-white">
      {/* Top wave */}
      <div className="relative overflow-hidden">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full -mb-1">
          <path d="M0 60L60 50C120 40 240 20 360 15C480 10 600 20 720 25C840 30 960 30 1080 25C1200 20 1320 10 1380 5L1440 0V60H1380C1320 60 1200 60 1080 60C960 60 840 60 720 60C600 60 480 60 360 60C240 60 120 60 60 60H0Z" fill="#f8faff" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <img
                src="/images/anir-logo.jpg"
                alt="Anir Healthcare"
                className="h-12 w-12 rounded-xl object-cover border-2 border-white/20"
              />
              <div>
                <p className="font-display font-bold text-xl leading-tight">ANIR</p>
                <p className="text-accent text-xs font-semibold tracking-widest uppercase">Healthcare</p>
              </div>
            </Link>
            <p className="text-blue-200 text-sm leading-relaxed mb-5">
              Celebrating Wellness! A pharmaceutical company dedicated to offering the best finished formulations in the healthcare sector.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/anirheathcare?igsh=cmU2ZmZwYjh0YmE4"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors duration-200"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/share/1Evsowy5F1/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors duration-200"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-sm tracking-wider uppercase text-blue-300 mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { to: '/', label: 'Home' },
                { to: '/about', label: 'About Us' },
                { to: '/products', label: 'Our Products' },
                { to: '/contact', label: 'Contact Us' },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-blue-200 hover:text-white text-sm transition-colors duration-200 flex items-center gap-2 group"
                  >
                    <span className="text-accent group-hover:translate-x-1 transition-transform duration-200">→</span>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-semibold text-sm tracking-wider uppercase text-blue-300 mb-5">Key Products</h4>
            <ul className="space-y-3">
              {['ANIPRO', 'ANROVIT-GOLD', 'KALNIR-PLUS', 'ANRO-SP', 'CLAVINIR-CV 625', 'LIVNIR-DS'].map((name) => (
                <li key={name}>
                  <Link
                    to="/products"
                    className="text-blue-200 hover:text-white text-sm transition-colors duration-200 flex items-center gap-2 group"
                  >
                    <span className="text-accent group-hover:translate-x-1 transition-transform duration-200">→</span>
                    {name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-sm tracking-wider uppercase text-blue-300 mb-5">Contact Us</h4>
            <ul className="space-y-4 text-sm text-blue-200">
              <li className="flex gap-3">
                <span className="text-accent mt-0.5 flex-shrink-0">📍</span>
                <span>T-5041, Sterling Ascentia, Opposite Bellandur, Bengaluru, Karnataka – 560103, India</span>
              </li>
              <li className="flex gap-3 items-center">
                <span className="text-accent flex-shrink-0">📧</span>
                <a href="mailto:anirhealthcare@gmail.com" className="hover:text-white transition-colors">
                  anirhealthcare@gmail.com
                </a>
              </li>
              <li className="flex gap-3 items-center">
                <span className="text-accent flex-shrink-0">📞</span>
                <a href="tel:+918294703147" className="hover:text-white transition-colors">
                  +91 82947 03147
                </a>
              </li>
              <li className="flex gap-3 items-center">
                <span className="text-accent flex-shrink-0">📞</span>
                <a href="tel:+917979878458" className="hover:text-white transition-colors">
                  +91 79798 78458
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-blue-300">
          <p>© {year} Anir Healthcare. All rights reserved.</p>
          <p className="italic">Celebrating Wellness 🌿</p>
        </div>
      </div>
    </footer>
  );
}
